'use strict';

var _swellRewardsCurrencies = require('./swell-rewards-currencies.js');

var _swellRewardsCurrencies2 = _interopRequireDefault(_swellRewardsCurrencies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.SwellMVMT = {
  mvmtCachedRates: null,

  addFlowSessionParams: function addFlowSessionParams(opts) {
    var session = JSON.parse(localStorage.getItem('_f60_session'));

    opts.flow_session_id = session.id;
    opts.flow_ip_address = session.ip;

    opts.flow_experience = session.experience && session.experience.key ? session.experience.key : 'standard';
    opts.flow_currency_code = session.geo && session.geo.currency && session.geo.currency.iso_4217_3 ? session.geo.currency.iso_4217_3 : 'USD';

    return opts;
  },
  getCurrentCurrency: function getCurrentCurrency() {
    var session = JSON.parse(localStorage.getItem('_f60_session'));

    return session.geo.currency.iso_4217_3;
  },
  asyncForEach: function asyncForEach(items, next, callback) {
    var transformed = new Array(items.length);
    var count = 0;

    items.forEach(function (item, index) {
      next(item, function (transformedItem) {
        transformed[index] = transformedItem;
        count += 1;
        if (count === items.length) return callback(transformed);
      });
    });
  },
  getPointsArrayFormattedAsCurrency: function getPointsArrayFormattedAsCurrency(pointsArr, callback) {
    SwellMVMT.asyncForEach(pointsArr, SwellMVMT.getPointsFormattedAsCurrency, callback);
  },
  getPointsFormattedAsCurrency: function getPointsFormattedAsCurrency(points, callback) {
    if (SwellMVMT.mvmtCachedRates) {
      var currency_iso = SwellMVMT.getCurrentCurrency();
      var rate = SwellMVMT.mvmtCachedRates.rates[currency_iso];

      if (rate) {
        var format = SwellMVMT.mvmtCachedRates.formats[currency_iso];
        var creditBalance = Math.round(rate * points);
        var amount = format.replace('{amount}', creditBalance);

        if (callback) {
          callback(amount);
        }
      } else {
        // need to use flow to convert
        var session = JSON.parse(localStorage.getItem('_f60_session'));
        var usdBalance = points / 10.0;
        var baseCurrencyISO = 'USD';
        var conversionURL = 'https://api.flow.io/mvmt/experiences/conversions/' + baseCurrencyISO.toLowerCase() + '/' + usdBalance + '?ip=' + session.ip + '&experience=' + session.experience.key + '&currency=' + currency_iso;
        // var conversionURL = "https://api.flow.io/mvmt-sandbox/experiences/conversions/" + baseCurrencyISO.toLowerCase() + "/" + usdBalance + "?ip=" + session.ip + "&experience=" + session.experience.key + "&currency=" + currency_iso;

        $.ajax({
          beforeSend: function beforeSend(request) {
            request.setRequestHeader('Authorization', 'Session ' + session.id);
          },

          dataType: 'json',
          url: conversionURL,
          success: function success(data) {
            if (callback) {
              callback(data.label);
            }
          }
        });
      }
    } else {
      SwellMVMT.refreshConversionRates(function () {
        SwellMVMT.getPointsFormattedAsCurrency(points, callback);
      });
    }
  },
  getFormattedCreditBalance: function getFormattedCreditBalance(callback) {
    var details = swellAPI.getCustomerDetails();

    SwellMVMT.getPointsFormattedAsCurrency(details.pointsBalance, callback);
  },
  getFormattedRewardAmount: function getFormattedRewardAmount(callback) {
    if (this.mvmtCachedRates) {
      var currency_iso = this.getCurrentCurrency();
      var rate = this.mvmtCachedRates.referral_rates[currency_iso];

      if (rate) {
        var format = this.mvmtCachedRates.formats[currency_iso];
        var amount = format.replace('{amount}', rate);

        if (callback) {
          callback(amount);
        }
      } else {
        // need to use flow to convert
        var session = JSON.parse(localStorage.getItem('_f60_session'));
        var usdAmount = this.mvmtCachedRates.referral_rates.USD;
        var baseCurrencyISO = 'USD';
        var conversionURL = 'https://api.flow.io/mvmt/experiences/conversions/' + baseCurrencyISO.toLowerCase() + '/' + usdAmount + '?ip=' + session.ip + '&experience=' + session.experience.key + '&currency=' + currency_iso;
        // change for test store
        // var conversionURL = "https://api.flow.io/mvmt-sandbox/experiences/conversions/" + baseCurrencyISO.toLowerCase() + "/" + usdAmount + "?ip=" + session.ip + "&experience=" + session.experience.key + "&currency=" + currency_iso;

        $.ajax({
          beforeSend: function beforeSend(request) {
            request.setRequestHeader('Authorization', 'Session ' + session.id);
          },

          dataType: 'json',
          url: conversionURL,
          success: function success(data) {
            if (callback) {
              callback(data.label);
            }
          }
        });
      }
    } else {
      this.refreshConversionRates(function () {
        SwellMVMT.getFormattedRewardAmount(callback);
      });
    }
  },
  refreshConversionRates: function refreshConversionRates(callback) {
    SwellMVMT.mvmtCachedRates = _swellRewardsCurrencies2.default;
    callback(_swellRewardsCurrencies2.default);
  },
  mvmtRefreshEmbeds: function mvmtRefreshEmbeds() {
    swellAPI.refreshEmbeds();
    var userPoints = swellAPI.getCustomerDetails().pointsBalance;

    $('.swell-mvmt-credits').html(userPoints);
  },
  renderRewardTitle: function renderRewardTitle() {
    this.getFormattedRewardAmount(function (amount) {
      $('.referral-content-container').prepend('<h1>Give ' + amount + ', Get 100 Points</h1>');
    });
  }
};

// UNUSED
// window.onBeforeReferralLinkClickSaved = function(opts) {
//   opts = SwellMVMT.addFlowSessionParams(opts);
//   opts.flow_conversion_type = "referred_customer";
//   return opts;
// };